export enum CompensationMethodType {
  Exchange = "exchange",
  Storecredit = "storeCredit",
  Refund = "refund",
  Repair = "repair",
}
